<!--
 * @Author: your name
 * @Date: 2021-05-25 16:55:47
 * @LastEditTime: 2021-05-25 16:57:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\components\newfile\new1.vue
-->

<template>
  <div class="new1">
      
      <p style="text-align:center">
    <strong><span style="font-family: 宋体;font-size: 21px"><span style="font-family:宋体">双边气源保供应</span> <span style="font-family:宋体">造福百姓促发展</span></span></strong>
</p>
<p style="text-align:right">
    <strong><span style="font-family: 宋体;font-size: 19px"><span style="font-family:宋体">——重庆公司来西线接驳工程顺利完工</span></span></strong>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">2020年12月6日，经过为期两天的停气改造施工，重庆公司双福来西线管道接驳成功，此次接驳是重庆公司双福配气站扩容改造工程的重要起步环节，奠定了双福与走马区域持续、安全、平稳、保供的基础。</span></span>
</p>
<p style="text-indent: 37px; text-align: center;">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体"><img width="265" height="227" src="../../assets/Information/zx1.png" hspace="12"  style="text-indent: 37px; white-space: normal; background-image: url(../../assets/Information/zx1.png); background-position: center center; background-size: initial; background-repeat: no-repeat; background-attachment: initial; background-origin: initial; background-clip: initial; border: 1px solid rgb(221, 221, 221);"/></span></span>
</p>
<p style="text-indent: 37px">
    <strong><span style="font-family: 宋体;font-size: 19px"><span style="font-family:宋体">工期紧</span> &nbsp;<span style="font-family:宋体">任务重</span></span></strong>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">来西线双福接驳项目自今年</span><span style="font-family:宋体">9月12日取得中石油同意接驳批复至12月6日完成接驳碰口，历时3个月。由于中石油对来凤站、西彭站的改造，并没有给重庆公司预留足够的准备时间，因此必须在2个月内完成设计、施工方案确定，土地规划协调，并与设计单位、施工单位及重庆气矿沟通，确定最优方案等一系列工作。</span></span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">改造期间双福与走马区域内近十万用户将受停气影响。集团总裁谭佐龙在做工作部署时强调：必须提前</span><span style="font-family:宋体">48小时通知用户，同时做好施工组织，确保工期；做好用户解释工作，维护社会稳定；做好停气后的供气恢复和安全工作；维护施工现场秩序，无论遇到多大的阻力，都要确保本次接驳工程如期完成，并第一时间恢复供气。</span></span>
</p>
<p style="text-indent: 37px; text-align: center;">
    <span style=";font-family:宋体;font-size:19px">&nbsp;<img width="241" height="242" src="../../assets/Information/zx2.png" hspace="12" style="white-space: normal; background-image: url(../../assets/Information/zx1.png); background-position: center center; background-size: initial; background-repeat: no-repeat; background-attachment: initial; background-origin: initial; background-clip: initial; border: 1px solid rgb(221, 221, 221);"/><span style="font-family: 宋体; font-size: 19px;">&nbsp; &nbsp;</span></span>
</p>
<p style="margin-left:28px">
    <strong><span style="font-family: 宋体;font-size: 19px"><span style="font-family:宋体">战略起步</span> &nbsp;<span style="font-family:宋体">意义重大</span></span></strong>
</p>
<p style="text-indent:28px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">来西线接驳工程完工后，双福与走马区域将由单边供气变为双边供气，极大的保证了用户的平稳用气需求，也促进了公司的安全平稳运营。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">有了良好的开端，重庆公司将加快推进来西线双福阀室至双福配气站改造项目，进行输气管道工程和双福配气站改造工程建设等工作。待该项工程完工后，将彻底解决双福供气压力和供气能力不足的问题，保障用户的持续用气需求，同时，也为高新区走马镇的发展奠定基础。</span></span>
</p>
<p style=";text-align:right">
    <span style=";font-family:宋体;font-size:19px">&nbsp;<span style="font-family:宋体">文</span><span style="font-family:宋体">/图 何徐梅</span></span>
</p>
<p>
    <span style=";font-family:Calibri;font-size:14px">&nbsp;</span>
</p>
<p>
    <br/>
</p>



  </div>

</template>
<script>

  import router from '@/router'

  export default {
    components: {

    },
    data() {
      return {
        htmls:''

      }
    },
    created(){

    },
    methods:{


    }
  }
</script>
<style lang="sass">

</style>


